
import { defineComponent } from 'vue';
import PointInfo from '@/components/organisms/point/PointInfo.vue';
import { i18n } from '@/plugins/i18n';

export default defineComponent({
  name: 'PointTransferExpire',

  components: {
    PointInfo,
  },

  props: {
    pointTransfer: {
      type: Object,
      required: true,
    },
  },

  setup(_) {
    // Set title
    document.title = `失効${i18n.t('keyword.point')}`;

    return {};
  },
});
